import { Store } from "../../types/contexts/dependentContext2/store.types";
import { member } from "../../utils/api/member/member";

const initialState: Store = {
	dependent: null
};

export default initialState;
